import { ColumnsConfig } from 'components/shared/data/DataGrid/DataGrid.types';
import { Search } from 'store/search/search.types';

export const searchColumns: ColumnsConfig<Search> = () => [
  {
    field: 'firstName',
    renderer: 'agGroupCellRenderer',
    name: 'SEARCH.COLUMNS.FIRST_NAME',
    cellStyle: { display: 'flex', alignItems: 'center' },
    columnParams: { minWidth: 130 },
  },
  {
    field: 'lastName',
    name: 'SEARCH.COLUMNS.LAST_NAME',
    columnParams: { minWidth: 140, flex: 1 },
  },
  {
    field: 'identificationNumber',
    name: 'SEARCH.COLUMNS.IDENTIFICATION_NUMBER',
    columnParams: { minWidth: 150 },
  },
];
